import { AxiosInstance } from 'axios';
import { ReservationStayCardBillService } from 'services/Reservations';

export interface StayCardBillService {
  getAll: ReturnType<typeof ReservationStayCardBillService.getAll>;
  search: ReturnType<typeof ReservationStayCardBillService.search>;
  getBillTransactions: ReturnType<typeof ReservationStayCardBillService.getBillTransactions>;
  getBillPayments: ReturnType<typeof ReservationStayCardBillService.getBillPayments>;
  update: ReturnType<typeof ReservationStayCardBillService.update>;
  transferCharge: ReturnType<typeof ReservationStayCardBillService.transferCharge>;
  transferPayment: ReturnType<typeof ReservationStayCardBillService.transferPayment>;
  addNewBill: ReturnType<typeof ReservationStayCardBillService.addNewBill>;
  postTransaction: ReturnType<typeof ReservationStayCardBillService.postTransaction>;
  postPayment: ReturnType<typeof ReservationStayCardBillService.postPayment>;
  deleteBill: ReturnType<typeof ReservationStayCardBillService.deleteBill>;
  updateBillingGroup: ReturnType<typeof ReservationStayCardBillService.updateBillingGroup>;
  transferTransactionsToCompany: ReturnType<
    typeof ReservationStayCardBillService.transferTransactionsToCompany
  >;
  downloadReceiptPayment: ReturnType<typeof ReservationStayCardBillService.downloadReceiptPayment>;
  downloadGuestFolio: ReturnType<typeof ReservationStayCardBillService.downloadGuestFolio>;
  getIndivdualInvoice: ReturnType<typeof ReservationStayCardBillService.getIndivdualInvoice>;
  printIndivdualInvoice: ReturnType<typeof ReservationStayCardBillService.printIndivdualInvoice>;
  saveIndivdualInvoice: ReturnType<typeof ReservationStayCardBillService.saveIndivdualInvoice>;
  getProformaInvoice: ReturnType<typeof ReservationStayCardBillService.getProformaInvoice>;
  saveProformaInvoice: ReturnType<typeof ReservationStayCardBillService.saveProformaInvoice>;
  getAllProformaInvoices: ReturnType<typeof ReservationStayCardBillService.getAllProformaInvoices>;
}

export const initStayCardBillService = (axios: AxiosInstance): StayCardBillService => ({
  getAll: ReservationStayCardBillService.getAll(axios),
  search: ReservationStayCardBillService.search(axios),
  getBillTransactions: ReservationStayCardBillService.getBillTransactions(axios),
  getBillPayments: ReservationStayCardBillService.getBillPayments(axios),
  update: ReservationStayCardBillService.update(axios),
  transferCharge: ReservationStayCardBillService.transferCharge(axios),
  transferPayment: ReservationStayCardBillService.transferPayment(axios),
  addNewBill: ReservationStayCardBillService.addNewBill(axios),
  postTransaction: ReservationStayCardBillService.postTransaction(axios),
  postPayment: ReservationStayCardBillService.postPayment(axios),
  deleteBill: ReservationStayCardBillService.deleteBill(axios),
  updateBillingGroup: ReservationStayCardBillService.updateBillingGroup(axios),
  transferTransactionsToCompany:
    ReservationStayCardBillService.transferTransactionsToCompany(axios),
  downloadReceiptPayment: ReservationStayCardBillService.downloadReceiptPayment(axios),
  downloadGuestFolio: ReservationStayCardBillService.downloadGuestFolio(axios),
  getIndivdualInvoice: ReservationStayCardBillService.getIndivdualInvoice(axios),
  printIndivdualInvoice: ReservationStayCardBillService.printIndivdualInvoice(axios),
  saveIndivdualInvoice: ReservationStayCardBillService.saveIndivdualInvoice(axios),
  getProformaInvoice: ReservationStayCardBillService.getProformaInvoice(axios),
  saveProformaInvoice: ReservationStayCardBillService.saveProformaInvoice(axios),
  getAllProformaInvoices: ReservationStayCardBillService.getAllProformaInvoices(axios),
});
